import { blanketBackground } from "../../../constants/colors";
import { themed } from "../../../util/theme";
import { BlanketStyledProps } from "./BlanketStyled";

export const blanketTheme = themed({
    background: {
        "lodestar-light": blanketBackground,
        // TODO use the official color token for this at some point.
        "ursa-light": "rgba(36, 39, 50, 0.08)",
    },
});

export function getBackground({ themeMode }: BlanketStyledProps): string {
    return blanketTheme.background(themeMode);
}
